import dayjs from "dayjs"

// $cache startDate/endDate 默认值
let startDate = dayjs().subtract(7, 'day').format('YYYY-MM-DD'),
    endDate = dayjs().format('YYYY-MM-DD'),
    expire = dayjs(dayjs().add(1, 'day').format("YYYY-MM-DD")).diff(dayjs(), 's')

export default {
    // base
    "home": {
        meta: {
            title: "首页"
        },
        name: 'home',
        component: () =>
            import('_v/home/index')
    },
    "api/admin/sys/user/index": {
        meta: {
            title: '用户管理',
        },
        name: "user",
        component: () =>
            import('_v/admin/sys/user/index')
    },
    "api/admin/sys/org/index": {
        meta: {
            title: '组织机构管理',
        },
        name: "org",
        component: () =>
            import('_v/admin/sys/org/index')
    },
    "api/admin/sys/auth/index": {
        meta: {
            title: '功能授权',
        },
        path: 'authResources',
        name: 'authResources',
        component: () =>
            import('_v/admin/sys/org/auth')
    },
    "api/admin/sys/dict/index": {
        meta: {
            title: '词典管理',
        },
        name: "dict",
        component: () =>
            import('_v/admin/sys/dict/index')
    },
    "api/admin/sys/resource/index": {
        meta: {
            title: '资源管理',
        },
        component: () =>
            import('_v/admin/sys/resource/index')
    },
    "api/admin/sys/data/auth/index": {
        meta: {
            title: "数据授权",
        },
        name: "dataAuth",
        component: () =>
            import("_v/admin/sys/data-auth/index")
    },
    "api/shop/info": {
        meta: {
            title: "门店管理",
            keepAlive: true,
            cache: {
                sInfo: {
                    user: true,
                },
            },
        },
        name: "sInfo",
        component: () => import("_v/shop/s-info-list"),
    },
    "api/community/info": {
        meta: {
            title: "社区管理",
            keepAlive: true,
            cache: {
                cInfo: {
                    user: true,
                },
            },
        },
        name: "cInfo",
        component: () => import("_v/community/c-info-list"),
    },
    "api/merch/index": {
        meta: {
            title: "商品管理",
            keepAlive: true,
            cache: {
                active: {
                    user: true,
                },
                merchCatalog: {
                    user: true
                },
                merchInfo: {
                    user: true,
                    defaultVal: {
                        pageNo: 1,
                        pageSize: 10,
                        catalogId: "",
                        merchName: "",
                        enabled: "",
                    }
                }
            },
        },
        name: "merch",
        component: () => import("_v/merch/merch-tab"),
        children: {
            "api/merch/catalog": {
                meta: {
                    title: "品类管理",
                },
                name: "merchCatalog",
                component: () => import("_v/merch/m-catalog-list"),
            },
            "api/merch/info": {
                meta: {
                    title: "商品管理",
                },
                name: "merchInfo",
                component: () => import("_v/merch/m-info-list"),
            },
            "api/merch/analysis": {
                meta: {
                    title: "商品分析",
                },
                name: "mAnalysis",
                component: () => import("_v/merch/m-analysis-list"),
            },
        },
    },
    "api/merchSell/index": {
        meta: {
            title: "活动管理",
            keepAlive: true,
            cache: {
                active: {
                    user: true,
                },
                mActMs: {
                    user: true,
                },
                mActTg: {
                    user: true,
                },
                catalogIdMs: {
                    user: true
                },
                catalogIdTg: {
                    user: true
                }
            },
        },
        name: "merchSell",
        component: () => import("_v/merchSell/merchSell-tab"),
        children: {
            "api/merchSell/act?act_type=ms": {
                meta: {
                    title: "秒杀活动",
                },
                name: "mActMs",
                component: () => import("_v/merchSell/m-act-ms-list"),
            },
            "api/merchSell/act": {
                meta: {
                    title: "团购活动",
                },
                name: "mActTg",
                component: () => import("_v/merchSell/m-act-tg-list"),
            },
        },
    },
    "api/market/index": {
        meta: {
            title: "营销管理",
            keepAlive: true,
            cache: {
                active: {
                    user: true,
                },
                title: {
                    user: true,
                },
                nInfo: {
                    user: true,
                },
            },

        },
        name: "Market",
        component: () => import("_v/market/market-tab"),
        children: {
            "api/coupon/info": {
                meta: {
                    title: "优惠券",
                },
                name: "cInfo",
                component: () => import("_v/market/c-info-list"),
            },
            "api/notify/info": {
                meta: {
                    title: "广告管理",
                },
                name: "nInfo",
                component: () => import("_v/market/n-info-list"),
            },
        },
    },
    "api/team/index": {
        meta: {
            title: "团长管理",
            keepAlive: true,
            cache: {
                active: {
                    user: true,
                },
                tInfo: {
                    user: true,
                },
                tLeaderapplySq: {
                    user: true,
                },
                tLeaderapplyTc: {
                    user: true,
                },
            },
        },
        name: "Team",
        component: () => import("_v/team/team-tab"),
        children: {
            "api/team/info": {
                meta: {
                    title: "团长列表",
                },
                name: "tInfo",
                component: () => import("_v/team/t-info-list"),
            },
            "api/team/leaderapply?apply_act=sq": {
                meta: {
                    title: "申请列表",
                },
                name: "tLeaderapplySq",
                component: () => import("_v/team/t-leaderapply-sq-list"),
            },
            "api/team/leaderapply?apply_act=tc": {
                meta: {
                    title: "退出列表",
                },
                name: "tLeaderapplyTc",
                component: () => import("_v/team/t-leaderapply-tc-list"),
            },
        },
    },
    "api/member/index": {
        meta: {
            title: "会员管理",
            keepAlive: true,
            cache: {
                active: {
                    user: true,
                },
                memberInfo: {
                    user: true,
                    defaultVal: {
                        pageNo: 1,
                        pageSize: 20,
                        realname: "",
                        vipGrade: "",
                        startDate: "",
                        endDate: "",
                    }
                },
                mRecharge: {
                    user: true,
                    defaultVal: {
                        pageNo: 1,
                        pageSize: 10,
                        nickName: "",
                        payType: "",
                        rechargeStatus: "",
                        startDate: "",
                        endDate: "",
                    }
                }
            },

        },
        name: "member",
        component: () => import("_v/member/member-tab"),
        children: {
            "api/member/info": {
                meta: {
                    title: "会员列表",
                },
                name: "memberInfo",
                component: () => import("_v/member/m-info-list"),
            },
            "api/member/analysis": {
                meta: {
                    title: "会员分析",
                },
                name: "memberAnalysis",
                component: () => import("_v/member/m-analysis"),
            },
            "api/member/recharge": {
                meta: {
                    title: "充值列表",
                },
                name: "mRecharge",
                component: () => import("_v/member/m-recharge-list"),
            },
        },
    },
    "api/order/index": {
        meta: {
            title: "订单管理",
            keepAlive: true,
            cache: {
                active: {
                    user: true,
                },
                oInfo: {
                    user: true,
                    defaultVal: {
                        pageNo: 1,
                        pageSize: 10,
                        orderNo: "",
                        orderStatus: "",
                        applyModule: "",
                        shopId: "",
                        startDate: "",
                        endDate: "",
                    },
                },
                gBill: {
                    defaultVal: {
                        pageNo: 1,
                        pageSize: 10,
                        goodsNo: "",
                        goodsStatus: "",
                        applyModule: "",
                        startDate: "",
                        endDate: "",
                    },
                    user: true,
                },
            },

        },
        name: "oIndex",
        component: () => import("_v/order/o-index-tab"),
        children: {
            "api/goods/bill": {
                meta: {
                    title: "货单列表",
                },
                name: "gBill",
                component: () => import("_v/order/g-bill-list"),
            },
            "api/order/info": {
                meta: {
                    title: "订单列表",
                },
                name: "oInfo",
                component: () => import("_v/order/o-info-list"),
            },
            "api/order/analysis": {
                meta: {
                    title: "订单分析",
                },
                name: "oAnalysis",
                component: () => import("_v/order/o-analysis-list"),
            },
        },
    },
    "api/sell/index": {
        meta: {
            title: "佣金管理",
            keepAlive: true,
            cache: {
                active: {
                    user: true,
                },
                sReward: {
                    defaultVal: {
                        pageNo: 1,
                        pageSize: 20,
                        realname: "",
                        leaderGrade: "",
                        startDate: "",
                        endDate: "",
                    },
                    user: true,
                },
                sExtract: {
                    user: true,
                },
                rewardAnalysis: {
                    user: true,
                },
                extractAnalysis: {
                    user: true,
                }
            },
        },
        name: "sIndex",
        component: () => import("_v/sell/s-index-tab"),
        children: {
            "api/sell/reward": {
                meta: {
                    title: "佣金列表",
                },
                name: "sReward",
                component: () => import("_v/sell/s-reward-list"),
            },
            "api/sell/extract": {
                meta: {
                    title: "提现列表",
                },
                name: "sExtract",
                component: () => import("_v/sell/s-extract-list"),
            },
            "api/sell/rewardAnalysis": {
                meta: {
                    title: "佣金分析",
                },
                name: "rewardAnalysis",
                component: () => import("_v/sell/s-reward-analysis-list"),
            },
            "api/sell/extractAnalysis": {
                meta: {
                    title: "提现分析",
                },
                name: "extractAnalysis",
                component: () => import("_v/sell/s-extract-analysis-list"),
            },
        },
    },
    "api/webcast/index": {
        meta: {
            title: "直播管理",
            keepAlive: true,
            cache: {
                active: {
                    user: true,
                },
                wRoom: {
                    user: true,
                },
                wMerch: {
                    user: true,
                },
            },

        },
        name: "wIndex",
        component: () => import("_v/webcast/w-index-tab"),
        children: {
            "api/webcast/room": {
                meta: {
                    title: "直播间",
                },
                name: "wRoom",
                component: () => import("_v/webcast/w-room-list"),
            },
            "api/webcast/merch": {
                meta: {
                    title: "商品库",
                },
                name: "wMerch",
                component: () => import("_v/webcast/w-merch-list"),
            }
        },
    },
    "api/service/index": {
        meta: {
            title: "售后管理",
            keepAlive: true,
            cache: {
                active: {
                    user: true,
                },
                sOrder: {
                    user: true,
                    defaultVal: {
                        pageNo: 1,
                        pageSize: 20,
                        orderNo: "",
                        serviceStatus: "",
                        startDate: "",
                        endDate: "",
                    }
                },
            },

        },
        name: "serviceIndex",
        component: () => import("_v/service/s-index-tab"),
        children: {
            "api/service/order": {
                meta: {
                    title: "售后处理",
                },
                name: "sOrder",
                component: () => import("_v/service/s-order-list"),
            },
            "api/service/analysis": {
                meta: {
                    title: "售后分析",
                },
                name: "sAnalysis",
                component: () => import("_v/service/s-analysis-list"),
            },
        },
    },
    "api/yeji/index": {
        meta: {
            title: "业绩管理",
            keepAlive: true,
            cache: {
                active: {
                    user: true,
                },
                merchAnalysis: {
                    user: true,
                },
                saleAnalysis: {
                    user: true,
                }
            },

        },
        name: "busIndex",
        component: () => import("_v/bus/s-index-tab"),
        children: {
            "api/bus/merchAnalysis": {
                meta: {
                    title: "商品分析",
                },
                name: "merchAnalysis",
                component: () => import("_v/bus/s-merch-analysis-list"),
            },
            "api/bus/saleAnalysis": {
                meta: {
                    title: "销售分析",
                },
                name: "saleAnalysis",
                component: () => import("_v/bus/s-sale-analysis-list"),
            },
        },
    },
    "api/bill/index": {
        meta: {
            title: "财务管理",
            keepAlive: true,
            cache: {
                active: {
                    user: true,
                },
                bInfo: {
                    user: true,
                    defaultVal: {
                        pageNo: 1,
                        pageSize: 20,
                        search: "",
                        billType: "",
                        startDate: "",
                        endDate: "",
                    }
                },
            },

        },
        name: "bIndex",
        component: () => import("_v/bill/b-index-tab"),
        children: {
            "api/bill/info": {
                meta: {
                    title: "账单列表",
                },
                name: "bInfo",
                component: () => import("_v/bill/b-info-list"),

            },
            "api/bill/analysis": {
                meta: {
                    title: "账单分析",
                },
                name: "bAnalysis",
                component: () => import("_v/bill/b-analysis-list"),
            },
        },
    },
    "api/operate/index": {
        meta: {
            title: "经营报表",
            keepAlive: true,
            cache: {
                active: {
                    user: true,
                },
                dayAnalysis: {
                    user: true,
                },
                weekAnalysis: {
                    user: true,
                },
                monthAnalysis: {
                    user: true,
                },
                quarterAnalysis: {
                    user: true,
                },
                yearAnalysis: {
                    user: true,
                },
            },

        },
        name: "operateIndex",
        component: () => import("_v/operate/s-index-tab"),
        children: {
            "api/operate/day": {
                meta: {
                    title: "销售日报",
                },
                name: "dayAnalysis",
                component: () => import("_v/operate/s-day-list"),

            },
            "api/operate/week": {
                meta: {
                    title: "销售周报",
                },
                name: "weekAnalysis",
                component: () => import("_v/operate/s-week-list"),
            },
            "api/operate/month": {
                meta: {
                    title: "销售月报",
                },
                name: "monthAnalysis",
                component: () => import("_v/operate/s-month-list"),
            },
            "api/operate/quarter": {
                meta: {
                    title: "销售季报",
                },
                name: "quarterAnalysis",
                component: () => import("_v/operate/s-quarter-list"),
            },
            "api/operate/year": {
                meta: {
                    title: "销售年报",
                },
                name: "yearAnalysis",
                component: () => import("_v/operate/s-year-list"),
            },
        },
    },
}